module.exports = __webpack_public_path__ + "img/zodiac.6574d305.jpg";